import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, reactive,  Ref,  ref } from 'vue';
import vSelect from 'vue-select';
import CModal from '../CModal.vue';
import CInput from '@/components/shared/CInput.vue';
import CAlert from '@/components/shared/CAlert.vue';
import CButton from '@/components/shared/CButton';
import CEmptyState from '@/components/shared/CEmptyState.vue';
import CPagination, { type PageData } from '@/components/shared/CPagination';
import CSwitch, { type CSwitchOption } from '@/components/shared/CSwitch';
import BoxElement, { type BoxData } from '@/components/shared/Box';
import type { ProductGuideSpecs, SpecsTemplateProductDTO, TemplateSpecDetailDTO } from '@/typings/pod/productGuideSpecs';
import { Provider } from '../../utils/PodProvider.enum';
import { buildCloudFrontUrl } from '@/utils/pathUtils';
import { getGuideSpecs, getSpecDetails, listTemplateProductSpecs } from '@/api/templateProduct';


export default /*#__PURE__*/_defineComponent({
  __name: 'TemplateProductSpecsModal',
  emits: ["import-specs", "close"],
  setup(__props, { emit }: { emit: ({
    (event: 'import-specs', value: ProductGuideSpecs): void;
    (event: 'close'): void;
}), expose: any, slots: any, attrs: any }) {

const SPEC_MODE = {
    ALL: 'all',
    WITH_GUIDELINES: 'guidelines'
}



const showLoader = ref(false);

const filters: CSwitchOption[] = [
    {
        label: 'All',
        value: SPEC_MODE.ALL,
    },
    {
        label: 'With guidelines',
        value: SPEC_MODE.WITH_GUIDELINES,
    }
];
const selectedSpecMode = ref(SPEC_MODE.ALL)
const filterByGuidelineActive = computed(() => selectedSpecMode.value == SPEC_MODE.WITH_GUIDELINES);

const pagination = reactive({
    page: 1,
    totalCount: 0,
    pageSize: 8,
    searchString: ''
})
const products = ref<BoxData<SpecsTemplateProductDTO>[]>([]);

const onPageChange = async (data: PageData) => {
    pagination.page = data.page;
    await getProducts(data.from);
};

const getProducts = async (from = 0) => {
    showLoader.value = true;
    selectedProduct.value = undefined;
    const { results, totalCount } = await listTemplateProductSpecs(
        from,
        pagination.pageSize,
        filterByGuidelineActive.value,
        pagination.searchString,
    );

    products.value = results.map((product) => {
        const name = product.name;
        return {
            id: product.id,
            title: name.toLowerCase().includes(Provider.PRINTFUL)
                ? name.split('(Printful)')[0]
                : name.split('(Printify)')[0],
            image: buildCloudFrontUrl(product.thumbnailPath, true),
            object: { ...product, podImageUrl: buildCloudFrontUrl(`app/images_pod/thumbnails/${product.podImageUrl}`, true)}
        };
    });

    pagination.totalCount = totalCount;
    showLoader.value = false;
};

const selectedProduct: Ref<BoxData<SpecsTemplateProductDTO> | undefined> = ref();
const onProductSeleted = (product: BoxData<SpecsTemplateProductDTO>) => {
    selectedProduct.value = {...product}
};

const nextBtnText = computed(() => {
    const text = 'Next'
    if (!selectedProduct.value) return text;

    return selectedProduct.value.object?.hasGuidelines
        ? text
        : 'Confirm'
});

const specDetails = reactive({
    show: false,
    templates: [] as TemplateSpecDetailDTO[],
    printAreas: [] as TemplateSpecDetailDTO['listEps'],
    selectedTemplate: undefined as TemplateSpecDetailDTO | undefined,
    selectedPrintArea: undefined as number | undefined,
});

const onNextHandler = async () => {
    const product = selectedProduct.value?.object
    if (!product) return;

    if (!product.hasGuidelines) {
        await emitProductSpecs(product.id);
        return;
    }

    specDetails.show = true;
    const details = await getSpecDetails(product.id);
    specDetails.templates = [...details];

    if (details.length > 1) return;

    const size = details[0];

    if (size.listEps.length > 1) {
        specDetails.selectedTemplate = details[0];
        specDetails.printAreas = details[0].listEps;
        return;
    }

    await emitProductSpecs(size.id, Number(size.listEps[0].id));
};

const onSizeChange =  () => {
    const template = specDetails.selectedTemplate;
    specDetails.selectedPrintArea = undefined;
    if (!template) return;

    specDetails.selectedPrintArea = Number(template.listEps[0].id);

    specDetails.printAreas = [...template.listEps];
}

const emitProductSpecs = async (templateId?: string, epsId?: number) => {
    if (!templateId?.length) return;
    const podProductSpecs = await getGuideSpecs(templateId, epsId);
    emit('import-specs', podProductSpecs);
    onClose();
}

const onClose = () => {
    clearAll();
    emit('close');
};

const vSelectReducer = (option: Record<string, number>) => option.id;

const clearAll = () => {
    pagination.page = 1;
    pagination.searchString = '';
    selectedProduct.value = undefined;
    resetSpecDetails();
};

const resetSpecDetails = () => {
    specDetails.show = false;
    specDetails.templates = [];
    specDetails.printAreas = [];
    specDetails.selectedTemplate = undefined;
    specDetails.selectedPrintArea = undefined;
}

onMounted(() => {
    getProducts();
});

return { __sfc: true,SPEC_MODE, emit, showLoader, filters, selectedSpecMode, filterByGuidelineActive, pagination, products, onPageChange, getProducts, selectedProduct, onProductSeleted, nextBtnText, specDetails, onNextHandler, onSizeChange, emitProductSpecs, onClose, vSelectReducer, clearAll, resetSpecDetails, vSelect, CModal, CInput, CAlert, CButton, CEmptyState, CPagination, CSwitch, BoxElement }
}

})